import getcdn from "~/modules/get_cdn_link"
import Img from "~/components/UI/Image"
import Text from "~/components/UI/Text"
import { useTranslation } from "~/i18n"

const Info = () => {
  const [t] = useTranslation()
  return (
    <>
      <Img smStyle={{ marginBottom: 24 }} height={32} width={160} src={getcdn('img/logo_header.png?ver=3')} alt="infina" />
      <Text opacity={0.7}>
        {t('Đồng Sở hữu & Khai thác bởi:')}
      </Text>
      <Text margin='16px 0 4px 0' bold>
        {t('Công Ty Cổ Phần Real Stake Việt Nam')}
      </Text>
      <Text style={{ opacity: 0.7 }}>
        {t`Mã số doanh nghiệp: `} 0315685484
        <br />
        {t`Nơi cấp: `}{t`Sở Kế Hoạch & Đầu tư TP. Hồ Chí Minh cấp ngày `}18/05/2019
      </Text>

      <Text margin='16px 0 4px 0' bold>
        {t('Công ty Cổ phần Real Stake Fintech')}
      </Text>
      <Text style={{ opacity: 0.7 }}>
        {t`Mã số doanh nghiệp: `} 0316552631
        <br />
        {t`Nơi cấp: `}{t`Sở Kế Hoạch & Đầu tư TP. Hồ Chí Minh cấp ngày `}23/10/2020
      </Text>
    </>
  )
}

export default Info